// extracted by mini-css-extract-plugin
module.exports = {"body":"_2-0Y3--WRg07XilsR7RUlV","pad-control":"_3KEuqvcgj_4NYvy64CJIqQ","dialog":"_25U5wud3K0Pnfmrn1nXx2c","btn-delete":"_3ygFwmLJHcUV3T6RmGe59r"};